import React from "react";
import { DatePicker } from "antd";
import dayjs from "dayjs";
import { $t } from "~/i18n.js";

export const DatePickerGA = ({
  id = "",
  value = null,
  onChange = (e) => {},
  disabledDate = null,
  marginTop = 12,
  ...args
}) => {
  
  // Convert YYYY-MM-DD string to dayjs object
  const parsedValue = value && typeof value === 'string' ? dayjs(value, "YYYY-MM-DD") : value;
  
  const triggerSave = (date) => {
    onChange(date ? date.format("YYYY-MM-DD") : null);
  }
  
  return (
    <DatePicker
      format={localStorage.localeFormat}
      style={{ marginTop: marginTop, width: 150 }}
      value={parsedValue}
      onChange={triggerSave}
      allowClear={false}
      placeholder={$t("selecteer datum")}
      disabledDate={disabledDate}
      {...args}
    />
  );
};
